// extracted by mini-css-extract-plugin
export default {"wrapper":"W_PaymentTreeDonateContent_wrapper__rne6f"};